import React, { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';
import { Badge } from '../ui/badge';
import { Progress } from '../ui/progress';
import { Target, Plus } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const RocksWidget = () => {
  const [rocks, setRocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [level, setLevel] = useState('company');

  useEffect(() => {
    fetchRocks();
  }, [level]);

  const fetchRocks = async () => {
    try {
      const response = await axios.get(`${API}/director/rocks`, {
        params: { level }
      });
      setRocks(response.data);
    } catch (error) {
      console.error('Error fetching rocks:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'on_track': return 'bg-green-600';
      case 'at_risk': return 'bg-yellow-600';
      case 'off_track': return 'bg-red-600';
      default: return 'bg-gray-600';
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'on_track': return <Badge className="bg-green-600">On Track</Badge>;
      case 'at_risk': return <Badge className="bg-yellow-600">At Risk</Badge>;
      case 'off_track': return <Badge variant="destructive">Off Track</Badge>;
      default: return <Badge variant="secondary">{status}</Badge>;
    }
  };

  if (loading) {
    return <div className="text-center py-8">Loading...</div>;
  }

  return (
    <div className="space-y-3">
      {/* Level Filter */}
      <div className="flex justify-between items-center">
        <Select value={level} onValueChange={setLevel}>
          <SelectTrigger className="w-[140px] h-8">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="company">Company</SelectItem>
            <SelectItem value="market">Market</SelectItem>
            <SelectItem value="team">Team</SelectItem>
            <SelectItem value="individual">Individual</SelectItem>
          </SelectContent>
        </Select>
        <Badge variant="outline" className="text-xs">
          <Target className="h-3 w-3 mr-1" />
          Q4 2025
        </Badge>
      </div>

      {/* Rocks List */}
      {rocks.length > 0 ? (
        <div className="space-y-2 max-h-72 overflow-y-auto">
          {rocks.map((rock, idx) => (
            <div key={idx} className="p-3 border rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 transition">
              <div className="flex justify-between items-start mb-2">
                <div className="flex-1">
                  <div className="font-semibold text-sm">{rock.title}</div>
                  <div className="text-xs text-gray-600 mt-1">{rock.owner || 'Unassigned'}</div>
                </div>
                {getStatusBadge(rock.status)}
              </div>
              <Progress value={rock.progress || 0} className="h-2" />
              <div className="text-xs text-gray-600 mt-1">{rock.progress || 0}% complete</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 border-2 border-dashed rounded-lg">
          <Target className="h-8 w-8 mx-auto mb-2 text-gray-400" />
          <p className="text-sm">No rocks for this quarter</p>
          <p className="text-xs mt-1">Add rocks from EOS module</p>
        </div>
      )}
    </div>
  );
};

export default RocksWidget;